<template>
  <h1>{{ $t('About Page') }}</h1>
</template>
